import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  Box,
  Grid,
  Button,
  Grid2,
  Typography,
  Paper,
  Dialog,
  DialogContent,
  DialogTitle,
  TextField,
  MenuItem,
  Select,
  DialogActions,
  Stack,
} from "@mui/material";
import Table from "../../Components/TableExport";
import { RoutingGuideRecordsColumns } from "../../ColumnsConfig/RoutingGuidesColumn";
import loaderGif from "../../Assests/loader.gif";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import "react-notifications/lib/notifications.css";
import BulkUploadSection from "./BulkUploadRecords";
import ConfirmationModal from "../../Common/ConfirmationModal";
import {
  fetchRoutingGuideRecords,
  createRoutingGuideRecord,
  updateRoutingGuideRecord,
  deleteRoutingGuideRecord,
  updateRoutingGuide,
  fetchFacilities,
  fetchCarriers,
  fetchServiceLevels,
  fetchStores,
  fetchCommodityCodes,
  InitialfetchRoutingGuides,
} from "../../Services/RoutingGuidesDetails";
import RoutingGuideForm from "../../Modals/RoutingGRecordsFormDialog";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import "./Comments.css";

const RoutingGuideDetails = () => {
  const { routing_guide_id } = useParams();
  const { guideId } = useParams();
  const [searchValues, setSearchValues] = useState({
    consolidator: "",
    dc: "",
    store: "",
    service_level: "",
    carrier: "",
    department: "",
  });

  const fieldNameMapping = {
    consolidator: "Consolidator",
    dc: "DC",
    store: "Store",
    service_level: "Service Level",
    carrier: "Carrier",
    department: "Department",
  };
  // Update API parameter mapping
  const fieldToApiParamMapping = {
    consolidator: "consolidatorId",
    dc: "dcId",
    store: "storeId",
    service_level: "serviceLevelId",
    carrier: "carrierId",
    department: "department",
  };

  const [rowToDelete, setRowToDelete] = useState(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [consolidators, setConsolidators] = useState([]);
  const [dcs, setDcs] = useState([]);
  const [carriers, setCarriers] = useState([]);
  const [serviceLevels, setServiceLevels] = useState([]); // Change to empty array
  const [commodityCodes, setCommodityCodes] = useState(["bncnbx"]);
  const [supplierDetail, setSupplierDetail] = useState(null);
  const [openAddNote, setOpenAddNote] = useState(false);
  const [openEditVendor, setOpenEditVendor] = useState(false);
  const [vendorNotesData, setRoutingGuideRecordsData] = useState([]);
  const [formValues, setFormValues] = useState({
    deptNumber: "",
    contact: "",
    phone: "",
    fax: "",
    note: "",
  });
  const [vendorEditValues, setVendorEditValues] = useState({});
  const [isEditMode, setIsEditMode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [stores, setStores] = useState([]);
  const [newComment, setNewComment] = useState("");
  const [isLoadingRecords, setIsLoadingRecords] = useState(false);
  const [hasErrors, setHasErrors] = useState(false);
  const [hasFormErrors, setHasFormErrors] = useState(false);

  const Division = [
    { id: 1000, value: "Neiman Marcus Stores", label: "Neiman Marcus Stores" },
    { id: 2000, value: "Neiman Marcus Direct", label: "Neiman Marcus Direct" },
    { id: 3000, value: "Bergdorf Goodman", label: "Bergdorf Goodman" },
    { id: 4000, value: "Last Call", label: "Last Call" },
  ];
  const storesmock = [
    { id: "All Stores", name: "All Stores" },
    { id: "All ECDC Stores", name: "All ECDC Stores" },
    { id: "All WCSC Stores", name: "All WCSC Stores" },
    { id: "All PNDC Stores", name: "All PNDC Stores" },
  ];

  const refreshData = async () => {
    try {
      setLoading(true);
      const vendors = await InitialfetchRoutingGuides(routing_guide_id);
      console.log("vendors", vendors.body.data);

      const supplier = vendors.body.data;
      console.log("supplier", supplier);

      if (supplier) {
        setSupplierDetail(supplier);
        setVendorEditValues(supplier);
        const records = await fetchRoutingGuideRecords(
          supplier.routing_guide_id
        );
        console.log("supplier", records);
        setRoutingGuideRecordsData(Array.isArray(records) ? records : []);
      }
    } catch (error) {
      console.error("Error refreshing data:", error);
      NotificationManager.error("Error refreshing data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchDropdownData = async () => {
      try {
        const [
          facilitiesData,
          carrierData,
          serviceLevelData,
          storeData,
          commodityCodesData,
        ] = await Promise.all([
          fetchFacilities(),
          fetchCarriers(),
          fetchServiceLevels(),
          fetchStores(),
          fetchCommodityCodes(),
        ]);

        setConsolidators(facilitiesData);
        setDcs(facilitiesData);
        setCarriers(carrierData);
        setServiceLevels(serviceLevelData);
        setStores(storeData);
        setCommodityCodes(commodityCodesData);
      } catch (error) {
        console.error("Error fetching dropdown data:", error);
        NotificationManager.error("Error loading some dropdown options");
      }
    };

    fetchDropdownData();
  }, []);

  useEffect(() => {
    const getSupplierData = async () => {
      try {
        const vendors = await InitialfetchRoutingGuides(routing_guide_id);
        console.log("vendors", vendors.body.data);

        const supplier = vendors.body.data;
        console.log("supplier", supplier);

        if (supplier) {
          setSupplierDetail(supplier);
          setVendorEditValues(supplier);

          // Set loading state to true before fetching records
          setIsLoadingRecords(true);

          // Lazy load the records
          const records = await fetchRoutingGuideRecords(
            supplier.routing_guide_id
          );
          console.log("supplier", records);

          setRoutingGuideRecordsData(Array.isArray(records) ? records : []);
        } else {
          console.warn(`No supplier found for guideId: ${guideId}`);
        }
      } catch (error) {
        console.error("Error in getSupplierData:", error);
        NotificationManager.error("Error loading routing guide data");
      } finally {
        // Set loading state to false after fetching records
        setIsLoadingRecords(false);
      }
    };

    getSupplierData();
  }, [guideId, routing_guide_id]);

  if (!supplierDetail) {
    return (
      <Box
        position="absolute"
        top={0}
        left={0}
        right={0}
        bottom={0}
        display="flex"
        justifyContent="center"
        alignItems="center"
        bgcolor="rgba(255, 255, 255, 0.8)"
        zIndex={1}
      >
        <img src={loaderGif} alt="Loading..." width={50} height={50} />
      </Box>
    );
  }
  const handleFormErrorChange = (hasErrors) => {
    setHasFormErrors(hasErrors);
  };
  const routingFields = [
    { label: "Guide Name", value: supplierDetail.guide_name },
    { label: "Supplier Site Id", value: supplierDetail.supplier_site_id },
    { label: " Division ", value: supplierDetail.division_name },
    { label: "Vendor Name", value: supplierDetail.vendor_name },
    {
      label: "Commodity Code",
      value: supplierDetail.commodity_code
        ? `${supplierDetail.commodity_code} - ${
            supplierDetail.commodity_code_name || ""
          }`
        : "",
    },
    { label: "Current Version", value: supplierDetail.current_version },
    { label: "Previous Version", value: supplierDetail.prev_version },
    {
      label: "Publish Date",
      value: new Date(supplierDetail.publish_date).toISOString().split("T")[0],
    },
    {
      label: "Effective Date",
      value: new Date(supplierDetail.effective_date)
        .toISOString()
        .split("T")[0],
    },
    {
      label: "Expiration Date",
      value: new Date(supplierDetail.expiration_date)
        .toISOString()
        .split("T")[0],
    },
  ];

  const handleAddNoteDialogOpen = (note = null, isNewRecordMode = false) => {
    // If no note is provided or it's a new record mode, use default values
    const initialValues = isNewRecordMode
      ? {
          routing_guide_id: routing_guide_id,
          ship_from_zip1: "",
          ship_from_zip2: "",
          consolidator: "",
          dc: "",
          facility_type: "",
          store_type: "",
          department_list: "",
          unit_type: "Carton",
          u_min: "",
          u_max: "",
          wt_min: "",
          wt_max: "",
          ship_message: "",
          carrier: "",
          service_level: "",
        }
      : {
          // Existing copy logic with formatted values
          record_id: note.record_id,
          routing_guide_id: note.routing_guide_id,
          ship_from_zip1: note.ship_from_zip1 || "",
          ship_from_zip2: note.ship_from_zip2 || "",
          consolidator: note.consolidator || "The Gilbert Company",
          dc: note.dc,
          facility_type: note.facility_type || "Consolidator",
          store_type: note.store || "",
          department_list: note.department || "N/A",
          unit_type: note.unit_type || "Carton",
          u_min: formatInitialValue(note.u_min),
          u_max: formatInitialValue(note.u_max),
          wt_min: formatInitialValue(note.wt_min),
          wt_max: formatInitialValue(note.wt_max),
          ship_message: note.ship_message,
          carrier: note.carrier,
          service_level: note.service_level,
        };
  
    setFormValues(initialValues);
    setIsEditMode(false);
    setOpenAddNote(true);
  };
  const handleSearchChange = (e, field) => {
    setSearchValues({
      ...searchValues,
      [field]: e.target.value,
    });
  };

  const handleDelete = (rowData) => {
    setRowToDelete(rowData);
    setIsDeleteModalOpen(true);
  };

  const handleConfirmDelete = async (rowData) => {
    setLoading(true);
    console.log("hdshjh", rowToDelete);

    try {
      await deleteRoutingGuideRecord(routing_guide_id, rowToDelete.record_id);
      setRoutingGuideRecordsData((prevData) =>
        prevData.filter((record) => record.record_id !== rowData.record_id)
      );
      NotificationManager.success("Record deleted successfully");
    } catch (error) {
      console.error("Error deleting record:", error);
      NotificationManager.error("Failed to delete record");
    }
    const records = await fetchRoutingGuideRecords(routing_guide_id);
    setRoutingGuideRecordsData(records);
    setLoading(false);
    setIsDeleteModalOpen(false);
  };

  const handleCancelDelete = () => {
    setIsDeleteModalOpen(false);
  };

  const handleEditNoteDialogOpen = (note, index) => {
    setIsEditMode(true);
  
    // Populate form with existing data and formatted values
    setFormValues({
      record_id: note.record_id,
      routing_guide_id: note.routing_guide_id,
      ship_from_zip1: note.ship_from_zip1 || "",
      ship_from_zip2: note.ship_from_zip2 || "",
      consolidator: note.consolidator || "The Gilbert Company",
      dc: note.dc,
      facility_type: note.facility_type,
      store_type: note.store,
      department_list: note.department,
      unit_type: note.unit_type,
      u_min: formatInitialValue(note.u_min),
      u_max: formatInitialValue(note.u_max),
      wt_min: formatInitialValue(note.wt_min),
      wt_max: formatInitialValue(note.wt_max),
      ship_message: note.ship_message,
      carrier: note.carrier,
      service_level: note.service_level_id,
    });
    setOpenAddNote(true);
  };

  const handleDialogClose = () => {
    setOpenAddNote(false);
  };

  // Modified handleInputChange to properly handle radio and select inputs
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // Special handling for radio group inputs
    if (
      name === "store_type" ||
      name === "department_type" ||
      name === "facility_type" ||
      name === "unit_type"
    ) {
      setFormValues((prev) => ({
        ...prev,
        [name]: value,
      }));
      return;
    }

    setFormValues((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Log the updated values
    console.log("Form value updated:", name, value);
  };

  const handleVendorInputChange = (e) => {
    const { name, value } = e.target;
    console.log(`Updating ${name} to ${value}`);
    setVendorEditValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async () => {
    const missingFields = validateRoutingGuideRecordForm();

    if (missingFields.length > 0) {
      // Display error notification with missing fields
      const missingFieldNames = missingFields
        .map((field) => field.label)
        .join(", ");
      NotificationManager.error(
        `Please fill in all required fields: ${missingFieldNames}`,
        "Validation Error",
        5000
      );
      return;
    }
    try {
      setLoading(true);

      if (isEditMode) {
        const updatedNote = {
          ...formValues,
        };

        console.log("Updating note", updatedNote);
        console.log("Updating record ID", formValues);

        const guide_index = formValues.routing_guide_id;
        const recordId = formValues.record_id;
        await updateRoutingGuideRecord(guideId, recordId, updatedNote);

        // Fetch updated data
        const records = await fetchRoutingGuideRecords(guide_index);
        setRoutingGuideRecordsData(records);

        NotificationManager.success("Record updated successfully");
        handleDialogClose();
      } else {
        console.log("Creating new routing record", formValues);
        const newNote = {
          routing_guide_id: routing_guide_id,
          ship_from_zip1: formValues.ship_from_zip1,
          ship_from_zip2: formValues.ship_from_zip2,
          consolidator: formValues.consolidator,
          dc: formValues.dc,
          // facility_type: formValues.facility_type,
          store: formValues.store_type,
          // department_type: formValues.department_type,
          department: formValues.department_type || formValues.department_list,
          unit_type: formValues.unit_type,
          u_min: formatInitialValue(formValues.u_min),
          u_max: formatInitialValue(formValues.u_max),
          wt_min: formValues.wt_min,
          wt_max: formValues.wt_max,
          ship_message: formValues.ship_message,
          service_level: formValues.service_level,
          carrier: formValues.carrier,
          contact: formValues.contact,
          // routing_guide_id: supplierDetail.supplier_site_id,
        };

        await createRoutingGuideRecord(guideId, newNote);
        const records = await fetchRoutingGuideRecords(
          supplierDetail.routing_guide_id
        );
        setRoutingGuideRecordsData(records);

        NotificationManager.success("Record added successfully");
        handleDialogClose();
      }
    } catch (error) {
      console.error("Failed to submit note:", error);
      NotificationManager.error("Failed to submit record");
    } finally {
      setLoading(false);
    }
  };

  const validateRoutingGuideRecordForm = () => {
    const requiredFields = [
      { field: "ship_from_zip1", label: "Ship From Zip 1" },
      { field: "consolidator", label: "Consolidator" },
      { field: "dc", label: "DC" },
      { field: "store_type", label: "Store Type" },
      { field: "department_list", label: "Department" },
      { field: "carrier", label: "Carrier" },
      { field: "service_level", label: "Service Level" },
      { field: "u_min", label: "Minimum Units" },
      { field: "u_max", label: "Maximum Units" },
      { field: "wt_min", label: "Minimum Weight" },
      { field: "wt_max", label: "Maximum Weight" },
    ];

    const missingFields = requiredFields.filter(
      ({ field }) =>
        !formValues[field] ||
        (typeof formValues[field] === "string" &&
          formValues[field].trim() === "")
    );

    return missingFields;
  };

  const handleSearch = async () => {
    try {
      const searchParams = {};
      Object.keys(searchValues).forEach((field) => {
        if (searchValues[field]) {
          const apiParam = fieldToApiParamMapping[field];
          if (apiParam) {
            searchParams[apiParam] = searchValues[field];
          }
        }
      });

      setLoading(true);
      const records = await fetchRoutingGuideRecords(
        routing_guide_id,
        searchParams
      );

      // Ensure records is an array, even if it's empty
      setRoutingGuideRecordsData(Array.isArray(records) ? records : []);

      // Optional: Add a notification if no results are found
      if (!records || records.length === 0) {
        NotificationManager.info(
          "No records found matching the search criteria"
        );
      }
    } catch (error) {
      console.error("Error searching records:", error);
      NotificationManager.error("Failed to search records");
      // Set to empty array in case of error
      setRoutingGuideRecordsData([]);
    } finally {
      setLoading(false);
    }
  };
  const handleEditVendorDialogOpen = () => {
    console.log("Opening edit dialog with supplier detail:", supplierDetail);
    setVendorEditValues({
      guide_name: supplierDetail.guide_name,
      supplier_site_id: supplierDetail.supplier_site_id,
      division_id: supplierDetail.division_id,
      vendor_name: supplierDetail.vendor_name,
      commodity_code_id: supplierDetail.commodity_code_id,
      current_version: supplierDetail.current_version,
      prev_version: supplierDetail.prev_version,
      publish_date: supplierDetail.publish_date,
      effective_date: supplierDetail.effective_date,
      expiration_date: supplierDetail.expiration_date,
      comments: supplierDetail.comments,
      // vendor_id: supplierDetail.vendor_id, // important for the API call
    });
    setOpenEditVendor(true);
  };

  const handleEditVendorSubmit = async () => {
    try {
      setLoading(true);

      // Format the date for the new comment
      const currentDate = new Date().toISOString().split("T")[0];

      // Prepare the comment text
      const commentToAdd = newComment.trim();

      // Only append if there's actually a new comment
      const updatedComments = commentToAdd
        ? `${vendorEditValues.comments || ""}\n[${currentDate}] ${commentToAdd}`
        : vendorEditValues.comments;

      const dataToUpdate = {
        ...vendorEditValues,
        comments: updatedComments,
      };

      const payload = {
        guide_name: dataToUpdate.guide_name,
        supplier_site_id: dataToUpdate.supplier_site_id,
        division_id: dataToUpdate.division_id,
        vendor_name: dataToUpdate.vendor_name,
        commodity_code_id: dataToUpdate.commodity_code_id,
        current_version: dataToUpdate.current_version,
        prev_version: dataToUpdate.prev_version,
        publish_date: dataToUpdate.publish_date,
        effective_date: dataToUpdate.effective_date,
        expiration_date: dataToUpdate.expiration_date,
        comments: dataToUpdate.comments,
      };

      const response = await updateRoutingGuide(
        supplierDetail.routing_guide_id,
        payload
      );

      setSupplierDetail({
        ...supplierDetail,
        ...response,
      });

      // Reset the new comment field
      setNewComment("");

      NotificationManager.success("Routing guide updated successfully");
      await refreshData();

      setOpenEditVendor(false);
    } catch (error) {
      console.error("Error updating routing guide:", error);
      NotificationManager.error("Failed to update routing guide");
    } finally {
      setLoading(false);
    }
  };

  const isDropdownField = (field) => {
    return ["consolidator", "dc", "service_level", "carrier", "store"].includes(
      field
    );
  };

  // Update getDropdownOptions to include stores
  const getDropdownOptions = (field) => {
    switch (field) {
      case "consolidator":
        return consolidators.map((item) => ({
          id: item.facility_id,
          name: item.name,
        }));
      case "dc":
        return dcs.map((item) => ({
          id: item.facility_id,
          name: item.name,
        }));
      case "service_level":
        return serviceLevels.map((item) => ({
          id: item.service_level_id,
          name: item.service_level,
        }));
      case "carrier":
        return carriers.map((item) => ({
          id: item.scac_id,
          name: item.scac_name,
        }));
      case "store": // Add this case
        return stores.map((item) => ({
          id: item.store_id,
          name: item.name || item.store_id, // Fallback to store_id if name is not available
        }));
      default:
        return [];
    }
  };

  const handleExportCSV = () => {
    const headers = [
      "routing_guide_id",
      "ship_from_zip1",
      "ship_from_zip2",
      "consolidator",
      "dc",
      "store",
      "department",
      "u_min",
      "u_max",
      "wt_min",
      "wt_max",
      "ship_message",
      "service_level",
      "carrier",
      "contact",
      "unit_type",
      "created_at",
      "updated_at",
    ];

    // Field mapping for special cases
    const fieldMapping = {
      consolidator: "consolidator_name",
      dc: "dc_name",
      service_level: "service_level_name",
      carrier: "carrier_name",
      unit_type: "unit_type",
    };

    // Convert the data to CSV format
    const csvData = vendorNotesData.map((row) => {
      return headers
        .map((header) => {
          // Use mapped field name if it exists, otherwise use original header
          const fieldName = fieldMapping[header] || header;
          let value = row[fieldName] || "";

          // If the value contains commas, quotes, or newlines, wrap it in quotes
          if (
            typeof value === "string" &&
            (value.includes(",") || value.includes('"') || value.includes("\n"))
          ) {
            return `"${value.replace(/"/g, '""')}"`;
          }
          return value;
        })
        .join(",");
    });

    // Add the header row to the beginning
    csvData.unshift(headers.join(","));

    // Create the CSV content
    const csvContent = csvData.join("\n");

    // Create a Blob and download link
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);

    // Set up the download
    link.setAttribute("href", url);
    link.setAttribute(
      "download",
      `routing_guide_${routing_guide_id}_${
        new Date().toISOString().split("T")[0]
      }.csv`
    );
    document.body.appendChild(link);

    // Trigger the download
    link.click();

    // Clean up
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const isFormValid = () => {
    const requiredFields = [
      "ship_from_zip1",
      "consolidator",
      "dc",
      "store_type",
      "department_list",
      "carrier",
      "service_level",
      "u_min",
      "u_max",
      "wt_min",
      "wt_max"
    ];
  
    return requiredFields.every(field => {
      const value = formValues[field];
      return value !== undefined && value !== null && value !== "";
    });
  };


// Helper function to format number values
const formatInitialValue = (value) => {
  if (value === null || value === undefined) return "";
  // Convert to integer if it's a number
  const numValue = Number(value);
  return Number.isInteger(numValue) ? parseInt(numValue) : value;
};

  return (
    <Box className="px-5 my-3" sx={{ borderRadius: "8px", padding: "5px" }}>
      <div>
        <NotificationContainer />
      </div>
      <Paper
        elevation={3}
        sx={{ padding: "20px", backgroundColor: "#3f506b", color: "white" }}
      >
        <Typography
          variant="h4"
          gutterBottom
          sx={{
            color: "white",
            backgroundColor: "#2c3e50", // Slightly darker background for contrast
            padding: "10px 20px", // Add padding for better spacing
            borderRadius: "8px", // Add rounded corners
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)", // Add subtle shadow for depth
            textAlign: "center", // Center-align the text
            fontWeight: "bold", // Make the text bold for emphasis
            textTransform: "uppercase", // Transform text to uppercase for a stronger header
          }}
        >
          Routing Guide Management
        </Typography>

        <Grid2 container spacing={2} alignItems="center">
          {routingFields.map((field, index) => (
            <React.Fragment key={index}>
              <Grid2 item xs={3}>
                <Typography
                  variant="body1"
                  color="white"
                  sx={{ textAlign: "right" }}
                >
                  <strong>{field.label}:</strong>
                </Typography>
              </Grid2>
              <Grid2 item xs={8}>
                <Typography variant="body1" color="white">
                  {field.value}
                </Typography>
              </Grid2>
            </React.Fragment>
          ))}
        </Grid2>

        {/* Beautified Comments Section */}
        <Box
          sx={{
            maxHeight: "120px", // Adjust the height as needed
            overflowY: "auto",
            backgroundColor: "rgba(255, 255, 255, 0.1)", // Optional: Add background for visibility
            padding: "10px",
            borderRadius: "4px",
          }}
        >
          <Typography variant="h6" sx={{ marginTop: "10px", color: "white" }}>
            Comments:
          </Typography>
          <Typography
            variant="body1"
            sx={{ whiteSpace: "pre-wrap", color: "516783" }}
          >
            {vendorEditValues.comments}
          </Typography>
        </Box>
      </Paper>
      <Button
        variant="contained"
        sx={{
          backgroundColor: "#516783",
          textTransform: "none",
          marginTop: "20px",
        }}
        onClick={handleEditVendorDialogOpen}
      >
        Edit Routing Guide
      </Button>
      <Typography variant="h4" sx={{ padding: "5px", marginTop: "20px" }}>
        Routing Guide Detail Records
      </Typography>
      <Box mb={2}>
        <Grid container spacing={2} alignItems="center">
          {Object.keys(searchValues).map((field, index) => (
            <Grid item xs={3} key={field}>
              <Box display="flex" alignItems="center" sx={{ mb: 0 }}>
                <Typography variant="body1" sx={{ mr: 1, width: "150px" }}>
                  {fieldNameMapping[field]}
                </Typography>
                {isDropdownField(field) ? (
                  <Select
                    value={searchValues[field]}
                    onChange={(e) => handleSearchChange(e, field)}
                    displayEmpty
                    size="small"
                    sx={{ ml: 1, width: "200px" }}
                  >
                    <MenuItem value="">
                      <em>All</em>
                    </MenuItem>
                    {getDropdownOptions(field).map((option) => (
                      <MenuItem key={option.id} value={option.id}>
                        {option.name}
                      </MenuItem>
                    ))}
                  </Select>
                ) : (
                  <TextField
                    variant="outlined"
                    size="small"
                    value={searchValues[field]}
                    onChange={(e) => handleSearchChange(e, field)}
                    sx={{ ml: 1, width: "200px" }}
                    inputProps={{ "aria-label": `search ${field}` }}
                  />
                )}
              </Box>
            </Grid>
          ))}
          <Grid item xs={3}>
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#3f506b",
                textTransform: "none",
                ml: 2,
              }}
              onClick={handleSearch}
            >
              Search
            </Button>
          </Grid>
        </Grid>
      </Box>
      <div>
        <p></p>
      </div>
      <Button
        variant="contained"
        sx={{
          backgroundColor: "#3f506b",
          textTransform: "none",
        }}
        onClick={handleExportCSV}
      >
        Export to CSV
      </Button>
      <div
        style={{ display: "flex", justifyContent: "flex-end", padding: "20px" }}
      >
        <BulkUploadSection
          commodityCodes={commodityCodes}
          consolidators={consolidators}
          dcs={dcs}
          carriers={carriers}
          service_levels={serviceLevels}
          stores={storesmock}
          guideId={routing_guide_id}
          onUploadComplete={refreshData}
          supplierdetail={supplierDetail}
        />
      </div>

      <ConfirmationModal
        isOpen={isDeleteModalOpen}
        message="Are you sure you want to delete this Record?"
        onConfirm={handleConfirmDelete}
        onCancel={handleCancelDelete}
      />

      {isLoadingRecords ? (
        // Display skeleton loader while records are being fetched
        <Box sx={{ padding: 2 }}>
          <Skeleton count={5} height={50} />
        </Box>
      ) : (
        // Render the actual records once loaded
        <Table
          rows={Array.isArray(vendorNotesData) ? vendorNotesData : []}
          columns={RoutingGuideRecordsColumns(
            handleEditNoteDialogOpen,
            handleDelete,
            handleAddNoteDialogOpen
          )}
          onDelete={handleDelete}
        />
      )}

      <Button
        variant="contained"
        sx={{
          backgroundColor: "#3f506b",
          textTransform: "none",
          marginLeft: "10px",
        }}
        onClick={() => handleAddNoteDialogOpen(null, true)}
      >
        Add New Record
      </Button>
      <Dialog
        open={openAddNote}
        onClose={handleDialogClose}
        maxWidth="md"
        fullWidth={true}
        PaperProps={{
          sx: {
            minWidth: "800px",
            minHeight: "80vh",
            maxHeight: "90vh",
            backgroundColor: "white",
            color: "black",
            m: 2,
            p: 2,
            overflowY: "auto",
          },
        }}
      >
        <DialogTitle
          sx={{
            borderBottom: "1px solid #e0e0e0",
            pb: 2,
            fontSize: "1.5rem",
            fontWeight: 500,
          }}
        >
          {isEditMode
            ? "Edit Routing Guide Record"
            : "Add Routing Guide Record"}
        </DialogTitle>
        <DialogContent sx={{ pt: 3, pb: 3 }}>
          <RoutingGuideForm
            formValues={formValues}
            handleInputChange={handleInputChange}
            consolidators={consolidators}
            dcs={dcs}
            serviceLevels={serviceLevels}
            carriers={carriers}
            stores={stores}
            supplierdetail={supplierDetail}
            onErrorChange={handleFormErrorChange}
          />
        </DialogContent>
        <DialogActions
          sx={{
            borderTop: "1px solid #e0e0e0",
            pt: 2,
            pb: 2,
            px: 3,
          }}
        >
          <Button onClick={handleDialogClose} variant="outlined" sx={{ mr: 1 }}>
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            variant="contained"
            disabled={hasFormErrors || !isFormValid()} // Add disable condition
            sx={{
              backgroundColor: "#3f506b",
              "&:hover": {
                backgroundColor: "#2c3e50",
              },
            }}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openEditVendor}
        onClose={() => setOpenEditVendor(false)}
        maxWidth="lg"
        PaperProps={{
          sx: {
            backgroundColor: "white",
            color: "black",
            width: "1000px",
            maxHeight: "90vh",
            overflowY: "auto",
            m: 1,
            "& .MuiDialogTitle-root": {
              backgroundColor: "#3f506b",
              color: "white",
              padding: "16px 24px",
              fontSize: "1.5rem",
              fontWeight: "600",
              marginBottom: "20px",
            },
            "& .MuiDialogContent-root": {
              padding: "16px 32px",
            },
          },
        }}
      >
        <DialogTitle>Edit Routing Guides</DialogTitle>
        <DialogContent>
          <Grid2 container spacing={4}>
            {/* Left Column: Form Fields */}
            <Grid2 item xs={6}>
              <Grid2 container spacing={3}>
                {/* Existing Form Fields */}
                {[
                  { label: "Guide Name", field: "guide_name", required: true },
                  { label: "Supplier Site Id", field: "supplier_site_id" },
                  { label: "Vendor Name", field: "vendor_name" },
                  {
                    label: "Current Version",
                    field: "current_version",
                    required: true,
                  },
                  {
                    label: "Previous Version",
                    field: "prev_version",
                    required: true,
                  },
                ].map((field) => (
                  <Grid2 item xs={12} key={field.field}>
                    <Box display="flex" alignItems="center">
                      <Typography
                        variant="body1"
                        sx={{
                          width: "150px",
                          fontWeight: "bold",
                          flexShrink: 0,
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {field.label}
                        {field.required && (
                          <Typography
                            component="span"
                            color="error"
                            sx={{ ml: 0.5 }}
                          >
                            *
                          </Typography>
                        )}
                        :
                      </Typography>
                      <TextField
                        name={field.field}
                        value={vendorEditValues[field.field] || ""}
                        onChange={handleVendorInputChange}
                        fullWidth
                        size="small"
                        sx={{ ml: 2 }}
                        error={
                          field.required &&
                          !vendorEditValues[field.field]?.trim()
                        }
                      />
                    </Box>
                  </Grid2>
                ))}

                {/* Date Fields */}
                {[
                  {
                    label: "Publish Date",
                    field: "publish_date",
                    required: true,
                  },
                  {
                    label: "Effective Date",
                    field: "effective_date",
                    required: true,
                  },
                  {
                    label: "Expiration Date",
                    field: "expiration_date",
                    required: true,
                  },
                ].map((dateField) => (
                  <Grid2 item xs={12} key={dateField.field}>
                    <Box display="flex" alignItems="center">
                      <Typography
                        variant="body1"
                        sx={{
                          width: "150px",
                          fontWeight: "bold",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {dateField.label}
                        {dateField.required && (
                          <Typography
                            component="span"
                            color="error"
                            sx={{ ml: 0.5 }}
                          >
                            *
                          </Typography>
                        )}
                        :
                      </Typography>
                      <TextField
                        name={dateField.field}
                        type="date"
                        value={
                          vendorEditValues[dateField.field]?.split("T")[0] || ""
                        }
                        onChange={handleVendorInputChange}
                        size="small"
                        sx={{ ml: 2 }}
                        InputLabelProps={{ shrink: true }}
                        error={
                          dateField.required &&
                          !vendorEditValues[dateField.field]
                        }
                      />
                    </Box>
                  </Grid2>
                ))}

                {/* Division Dropdown */}
                <Grid2 item xs={12}>
                  <Box display="flex" alignItems="center">
                    <Typography
                      variant="body1"
                      sx={{
                        width: "150px",
                        fontWeight: "bold",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      Division:
                    </Typography>
                    <Select
                      name="division_id"
                      value={vendorEditValues.division_id || ""}
                      onChange={handleVendorInputChange}
                      fullWidth
                      size="small"
                      sx={{ ml: 2 }}
                    >
                      {Division.map((division) => (
                        <MenuItem key={division.id} value={division.id}>
                          {division.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </Box>
                </Grid2>

                {/* Commodity Code Dropdown */}
                <Grid2 item xs={12}>
                  <Box display="flex" alignItems="center">
                    <Typography
                      variant="body1"
                      sx={{
                        width: "150px",
                        fontWeight: "bold",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      Commodity Code:
                    </Typography>
                    <Select
                      name="commodity_code_id"
                      value={vendorEditValues.commodity_code_id || ""}
                      onChange={handleVendorInputChange}
                      fullWidth
                      size="small"
                      sx={{ ml: 2 }}
                    >
                      {commodityCodes.map((code) => (
                        <MenuItem
                          key={code.commodity_code_id}
                          value={code.commodity_code_id}
                        >
                          {code.commodity_code} - {code.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </Box>
                </Grid2>
              </Grid2>
            </Grid2>

            <Stack
              spacing={3}
              sx={{
                width: "100%",
              }}
            >
              {/* Current Comments Section */}
              <div>
                <Typography
                  variant="h6"
                  sx={{
                    mb: 2,
                    fontWeight: "bold",
                    color: "#3f506b",
                  }}
                >
                  Current Comments:
                </Typography>
                <TextField
                  multiline
                  rows={6}
                  fullWidth
                  value={vendorEditValues.comments || ""}
                  InputProps={{ readOnly: true }}
                  placeholder="No comments available"
                />
              </div>

              {/* New Comments Section */}
              <div>
                <Typography
                  variant="h6"
                  sx={{
                    mb: 2,
                    fontWeight: "bold",
                    color: "#3f506b",
                  }}
                >
                  New Comment:
                </Typography>
                <TextField
                  multiline
                  rows={6}
                  fullWidth
                  name="newComment"
                  value={newComment}
                  onChange={(e) => setNewComment(e.target.value)}
                  placeholder="Enter new comment..."
                />
              </div>
            </Stack>
          </Grid2>

          {/* Action Buttons */}
          <Box
            sx={{
              mt: 3,
              pt: 2,
              borderTop: "1px solid #e0e0e0",
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
            }}
          >
            <Button
              onClick={() => setOpenEditVendor(false)}
              variant="outlined"
              sx={{
                color: "#3f506b",
                borderColor: "#3f506b",
                "&:hover": {
                  borderColor: "#2c3e50",
                  backgroundColor: "rgba(63, 80, 107, 0.04)",
                },
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={handleEditVendorSubmit}
              variant="contained"
              disabled={
                ![
                  "guide_name",
                  "current_version",
                  "prev_version",
                  "publish_date",
                  "effective_date",
                  "expiration_date",
                ].every((field) => vendorEditValues[field]?.trim())
              }
              sx={{
                backgroundColor: "#3f506b",
                color: "white",
                "&:hover": {
                  backgroundColor: "#2c3e50",
                },
              }}
            >
              Save
            </Button>
          </Box>

          {/* Loading Overlay */}
          {loading && (
            <Box
              position="absolute"
              top={0}
              left={0}
              right={0}
              bottom={0}
              display="flex"
              justifyContent="center"
              alignItems="center"
              bgcolor="rgba(255, 255, 255, 0.8)"
              zIndex={1}
            >
              <img src={loaderGif} alt="Loading..." width={50} height={50} />
            </Box>
          )}
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default RoutingGuideDetails;
